<template>
  <div class="auth-callback">
    <p>Loggar in…</p>
  </div>
</template>

<script>
import { onMounted } from "vue";
import { useRouter } from "vue-router";
import { useQuasar } from "quasar";
import { setToken } from "@/utils/auth";

export default {
  name: "AuthCallback",
  setup() {
    const router = useRouter();
    const $q = useQuasar();

    onMounted(async () => {
      // OAuth-callbacken redirectar hit med token i hash: #token=...
      const hash = window.location.hash || "";
      const match = hash.match(/token=([^&]+)/);
      if (match && match[1]) {
        await setToken(decodeURIComponent(match[1]));
        // Rensa hashen ur historiken
        window.history.replaceState(
          null,
          "",
          window.location.pathname + window.location.search
        );
        $q.notify({ type: "positive", message: "Inloggning lyckades!" });
        router.replace("/");
      } else {
        $q.notify({
          type: "negative",
          message: "Inloggning misslyckades.",
        });
        router.replace("/login");
      }
    });

    return {};
  },
};
</script>

<style scoped>
.auth-callback {
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-text-secondary);
}
</style>
